// extracted by mini-css-extract-plugin
export default {"component":"StatsMenu_component__QIi1B","container":"StatsMenu_container__lH5NX"};